import React, { ReactElement } from 'react';

export default function HouseExchange(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='64' viewBox='0 0 64 64' width='64' xmlns='http://www.w3.org/2000/svg'>
            <path d='M24.5 52.5H8.5V24' stroke='currentColor' />
            <path d='M57.5 38V52.5H37.5V47' stroke='currentColor' />
            <path d='M3 27L27.5 13L52 27' stroke='currentColor' strokeLinecap='round' />
            <path d='M60 39L47.5 32L46 33' stroke='currentColor' strokeLinecap='round' />
            <path d='M28 46.5L27.5 46.5L27.5 47L27.5 51.84L19.7282 44.5L27.5 37.16L27.5 42L27.5 42.5L28 42.5L34.5 42.5L34.5 46.5L28 46.5Z' stroke='currentColor' strokeLinecap='round' />
            <path d='M38 34.5L38.5 34.5L38.5 34L38.5 29.16L46.2718 36.5L38.5 43.84L38.5 39L38.5 38.5L38 38.5L31.5 38.5L31.5 34.5L38 34.5Z' stroke='currentColor' strokeLinecap='round' />
            <rect fill='currentColor' height='1' width='7' x='31' y='52' />
            <path d='M46 24H47V32L46 33V24Z' fill='#0E7680' />
        </svg>
    );
}